import React, { useEffect, useState } from 'react';
import { Animated } from 'react-native';

import styles from './position-indicator.style';
import { useColors } from '../../../hooks/lesson-player.context';

export function PositionIndicator({
  fragmentIndex,
  fragmentPosition,
  separatorWidth,
  fragmentWidth,
}) {
  const [value] = useState(new Animated.Value(0));
  const colors = useColors();

  useEffect(() => {
    const toValue =
      separatorWidth / 2 +
      (fragmentWidth + separatorWidth) * fragmentIndex +
      fragmentPosition * fragmentWidth -
      7;

    Animated.timing(value, {
      toValue,
      duration: 150,
      useNativeDriver: false,
    }).start();
  }, [fragmentIndex, fragmentPosition, separatorWidth, value, fragmentWidth]);

  return (
    <Animated.View
      style={[
        styles.indicator,
        {
          backgroundColor: colors.background,
          borderColor: colors.primary,
          transform: [{ translateX: value }],
        },
      ]}
    />
  );
}
